





































































import Vue from "vue";
import { mapState } from "vuex";
import AccountInfo from "../components/billing/account-info.vue";
import ServicePanel from "../components/billing/service-panel.vue";
import InvoiceList from "../components/billing/invoice-list.vue";
import CancelAccount from "../components/billing/cancel-account.vue";
import PlanSelector from "../components/billing/plan-selector.vue";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";

export default Vue.extend({
  components: { AccountInfo, ServicePanel, InvoiceList, CancelAccount, PlanSelector, BottomNavigation, BottomNavigationItem },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      currentMenuItemName: "account",
      showCancelAccount: false,
      showPlanSelector: false,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("goal", ["loading", "currentGoal"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapState("session", ["user"]),
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    pageTitle() {
      let title = "";
      switch (this.currentMenuItemName) {
        case "account":
          title = "Account";
          break;
        case "service":
          title = "Subscription";
          break;
        case "users":
          title = "Users";
          break;
        case "billing":
          title = "Billing";
          break;
        case "invoices":
          title = "Invoices";
          break;
        case "support":
          title = "Support";
          break;
      }

      return title;
    },
  },
  mounted() {
    this.$Notice.config({
      top: 120,
      duration: 3,
    });

    this.loadAccountInfo();

    abp.event.on("abp.notifications.received", this.handleNotificationReceived);
  },
  watch: {
    user(newValue) {
      if (newValue) {
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  beforeDestroy() {
    console.log("leave page");
    abp.event.off("abp.notifications.received", this.handleNotificationReceived);
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleNotificationReceived(userNotification) {
      let context = this as any;
      console.log(userNotification);
      if (userNotification.notification.entityId === context.billingAccount.id && userNotification.notification.data.version >= 0) {
        this.loadAccountInfo();
      }
    },
    mouseOver: function () {
      if (this.isCollapsed === true) {
        this.collapsedSider();
        this.hoverCollapseToggled = true;
      }
    },
    mouseLeave: function () {
      if (this.hoverCollapseToggled === true) {
        this.collapsedSider();
        this.hoverCollapseToggled = false;
      }
    },
    collapsedSider() {
      (this.$refs.sideMenu as any).toggleCollapse();
    },
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("goal/setActiveMenu", name);

      //if (this.lastMenuItemName === "checkins" && (this as any).currentGoalHasCheckpointUpdated === true) {
      //  this.loadGoal();
      //}
      //this.lastMenuItemName = name;
    },
    handleShowCancelAccount() {
      this.showCancelAccount = true;
    },
    handleWithdrawCancellation() {
      let context = this;
      context.$store
        .dispatch("billing/withdrawCancellation")
        .then(() => {
          context.$Notice.success({
            title: "Don't cancel",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
    handleCancelCancelAccount() {
      this.showCancelAccount = false;
    },
    handleChangePlan() {
      this.showPlanSelector = true;
    },
  },
});
